import { apiClient } from '@/lib/api/client'
import type { HelmOverview } from '@/lib/api/types'

/**
 * Headline counts for the dashboard and the inquiry list.
 *
 * They come from GET /overview, which counts everything the caller can see.
 * Lists are paginated, so a count taken from one stops at its first page -
 * that is what these numbers used to be. If /overview is unavailable (an API
 * that predates it, or a failed request) the page still renders, on the
 * page-based numbers, rather than failing.
 */
export function loadOverview(): Promise<HelmOverview | null> {
  return apiClient
    .getOverview()
    .then((overview) => (isOverview(overview) ? overview : null))
    .catch(() => null)
}

// A malformed answer falls back like a missing one rather than crashing the page.
function isOverview(value: unknown): value is HelmOverview {
  const candidate = value as HelmOverview | null
  return (
    typeof candidate?.inquiries?.total === 'number' &&
    typeof candidate?.consignments?.total === 'number'
  )
}

export { dashboardStats, inquiryStatusCount } from './overview-stats'
export type { DashboardStats } from './overview-stats'
